export default "__VITE_PUBLIC_ASSET__1b40cf2f__"